module.exports = __webpack_public_path__ + "static/img/oilSlogin.4532a454.png";